import { createFileRoute, redirect } from '@tanstack/react-router';
import * as v from 'valibot';
import Cookies from 'js-cookie';

export const Route = createFileRoute('/callback')({
  validateSearch: v.object({ code: v.string() }),
  beforeLoad: async ({ search }) => {
    const res = await fetch(
      `${import.meta.env.VITE_MAIA_API_PATH}/api/auth/exchange`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: search.code }),
      },
    );

    if (!res.ok) {
      throw new Error('Failed to exchange code for tokens');
    }

    const { tokenRes } = await res.json();

    Cookies.set('auth_tokens', JSON.stringify(tokenRes), {
      secure: true,
      sameSite: 'strict',
      expires: new Date(tokenRes.refreshTokenExpiresAt),
    });

    throw redirect({ to: '/dashboard' });
  },
});
